import styled, { css } from '../../../styled';
const BottomContent = styled.div `
  width: 100%;
  box-sizing: border-box;
  max-height: ${({ maxHeight, isExpand }) => isExpand ? 'max-content' : maxHeight};
  overflow: hidden;
  ${({ isExpand, isOverflow }) => isExpand &&
    isOverflow &&
    css `
      padding-bottom: 0;
    `};
`;
export default BottomContent;
//# sourceMappingURL=BottomContent.js.map